// extracted by mini-css-extract-plugin
export default {"validationContainer":"add-verification-service-modal__validation-container__IQl8F"};